function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { getFirebase } from './firebase';
import chunk from 'lodash/chunk';
var firestore = getFirebase().firestore();
firestore.settings({
  ignoreUndefinedProperties: true,
  merge: true
});
export default firestore;
export var FieldValue = getFirebase().firestore.FieldValue;
export var TIMESTAMP = FieldValue.serverTimestamp();
export var DELETE = FieldValue["delete"]();
function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}
export var firestoreDataUrl = function firestoreDataUrl(project, path) {
  return "https://console.firebase.google.com/u/0/project/".concat(project, "/firestore/data/").concat(encodeURIComponent(path));
};
export var getReferenceData = function getReferenceData(ref) {
  return ref.get().then(function (snap) {
    return snap.docs ? snap.docs.filter(function (docSnap) {
      return docSnap.exists;
    }).map(function (docSnap) {
      return docSnap.data();
    }) : snap.data();
  });
};
export var loopCollection = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(collectionReferenceOrQuery, loopFunc) {
    var batchSize,
      startAfterDocSnap,
      lastDocSnapInBatch,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            batchSize = _args.length > 2 && _args[2] !== undefined ? _args[2] : 10000;
            startAfterDocSnap = _args.length > 3 ? _args[3] : undefined;
            _context.next = 4;
            return loopCollectionBatch(collectionReferenceOrQuery, loopFunc, batchSize, startAfterDocSnap);
          case 4:
            lastDocSnapInBatch = _context.sent;
            if (!lastDocSnapInBatch) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", loopCollection(collectionReferenceOrQuery, loopFunc, batchSize, lastDocSnapInBatch));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function loopCollection(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var updateCollection = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(collectionReferenceOrQuery, updateFunc) {
    var batchSize,
      startAfterDocSnap,
      lastDocSnapInBatch,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            batchSize = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 400;
            startAfterDocSnap = _args2.length > 3 ? _args2[3] : undefined;
            _context2.next = 4;
            return updateCollectionBatch(collectionReferenceOrQuery, updateFunc, batchSize, startAfterDocSnap);
          case 4:
            lastDocSnapInBatch = _context2.sent;
            if (!lastDocSnapInBatch) {
              _context2.next = 10;
              break;
            }
            if (!startAfterDocSnap) {
              _context2.next = 9;
              break;
            }
            _context2.next = 9;
            return sleep(1000);
          case 9:
            return _context2.abrupt("return", updateCollection(collectionReferenceOrQuery, updateFunc, batchSize, lastDocSnapInBatch));
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function updateCollection(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var deleteCollection = function deleteCollection(collection) {
  var batchSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var collectionRef = typeof collection === 'string' ? firestore.collection(collection) : collection;
  var query = collectionRef.limit(batchSize);
  return new Promise(function (resolve, reject) {
    deleteQueryBatch(query, batchSize, resolve, reject);
  });
};
export var deleteSubcollections = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(documentRef) {
    var excludeCollections,
      collectionsToDelete,
      _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            excludeCollections = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : ['restorePoints'];
            console.log("[firestore.deleteSubcollections] Deleting subcollections for ".concat(documentRef.path, "..."));
            _context3.next = 4;
            return getDocumentSubcollectionPaths(documentRef);
          case 4:
            collectionsToDelete = _context3.sent;
            console.log("[firestore.deleteSubcollections] Deleting ".concat(collectionsToDelete.length, " subcollections..."));
            return _context3.abrupt("return", Promise.all(collectionsToDelete.filter(function (c) {
              return !excludeCollections.includes(c);
            }).map(function (c) {
              return deleteCollection(c);
            })).then(function () {
              return console.log('[firestore.deleteSubcollections] Subcollections deleted.');
            }));
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function deleteSubcollections(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
var loopCollectionBatch = function loopCollectionBatch(collectionReference, loopFunc, batchSize, startAfterDocSnap) {
  console.log("[firestore.loopCollectionBatch] Looping up to ".concat(batchSize, " docs, starting ").concat(startAfterDocSnap ? "after ".concat(startAfterDocSnap.id) : 'with the first doc'));
  var query = startAfterDocSnap ? collectionReference.startAfter(startAfterDocSnap).limit(batchSize) : collectionReference.limit(batchSize);
  return query.get().then( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(querySnapshot) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(querySnapshot.size === 0)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", Promise.resolve(null));
            case 2:
              _context5.next = 4;
              return querySnapshot.docs.reduce( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(promise, documentSnapshot) {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return promise;
                        case 2:
                          return _context4.abrupt("return", loopFunc(documentSnapshot));
                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));
                return function (_x7, _x8) {
                  return _ref5.apply(this, arguments);
                };
              }(), Promise.resolve());
            case 4:
              return _context5.abrupt("return", querySnapshot.docs[querySnapshot.docs.length - 1]);
            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function (_x6) {
      return _ref4.apply(this, arguments);
    };
  }());
};
var updateCollectionBatch = function updateCollectionBatch(collectionReference, updateFunc, batchSize, startAfterDocSnap) {
  console.log("[firestore.updateCollectionBatch] Updating up to ".concat(batchSize, " docs, starting ").concat(startAfterDocSnap ? "after ".concat(startAfterDocSnap.id) : 'with the first doc'));
  var query = startAfterDocSnap ? collectionReference.startAfter(startAfterDocSnap).limit(batchSize) : collectionReference.limit(batchSize);
  return query.get().then( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(querySnapshot) {
      var batch;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(querySnapshot.size === 0)) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return", Promise.resolve(null));
            case 2:
              batch = firestore.batch();
              _context7.next = 5;
              return Promise.all(querySnapshot.docs.map( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(documentSnapshot) {
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          return _context6.abrupt("return", updateFunc(batch, documentSnapshot));
                        case 1:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
                return function (_x10) {
                  return _ref7.apply(this, arguments);
                };
              }()));
            case 5:
              return _context7.abrupt("return", batch.commit().then(function () {
                return querySnapshot.docs[querySnapshot.docs.length - 1];
              }));
            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return function (_x9) {
      return _ref6.apply(this, arguments);
    };
  }());
};
var deleteQueryBatch = function deleteQueryBatch(query, resolve, reject) {
  query.get().then(function (snapshot) {
    var docsToDeleteCount = snapshot.size;
    if (docsToDeleteCount === 0) {
      return 0;
    }
    var batch = firestore.batch();
    snapshot.docs.forEach(function (doc) {
      return batch["delete"](doc.ref);
    });
    return batch.commit().then(function () {
      return docsToDeleteCount;
    });
  }).then(function (deletedCount) {
    if (deletedCount === 0) {
      resolve();
      return;
    }
    process.nextTick(function () {
      deleteQueryBatch(query, resolve, reject);
    });
  })["catch"](reject);
};
var getDocumentSubcollectionPaths = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(documentRef) {
    var documentSubcollectionPaths, collectionRefs;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            documentSubcollectionPaths = [];
            _context10.next = 3;
            return documentRef.listCollections();
          case 3:
            collectionRefs = _context10.sent;
            _context10.next = 6;
            return Promise.all(collectionRefs.map( /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(collectionRef) {
                var subcollection;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        documentSubcollectionPaths.push(collectionRef.path);
                        _context9.next = 3;
                        return collectionRef.get();
                      case 3:
                        subcollection = _context9.sent;
                        _context9.next = 6;
                        return Promise.all(subcollection.docs.map( /*#__PURE__*/function () {
                          var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(documentSnap) {
                            var subDocumentSubcollectionPaths;
                            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    _context8.next = 2;
                                    return getDocumentSubcollectionPaths(documentSnap.ref);
                                  case 2:
                                    subDocumentSubcollectionPaths = _context8.sent;
                                    documentSubcollectionPaths = [].concat(_toConsumableArray(documentSubcollectionPaths), _toConsumableArray(subDocumentSubcollectionPaths));
                                  case 4:
                                  case "end":
                                    return _context8.stop();
                                }
                              }
                            }, _callee8);
                          }));
                          return function (_x13) {
                            return _ref10.apply(this, arguments);
                          };
                        }()));
                      case 6:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));
              return function (_x12) {
                return _ref9.apply(this, arguments);
              };
            }()));
          case 6:
            return _context10.abrupt("return", documentSubcollectionPaths);
          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return function getDocumentSubcollectionPaths(_x11) {
    return _ref8.apply(this, arguments);
  };
}();
export var chunkBatches = function chunkBatches(db, largeArray, callback) {
  var chunkSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var batches = chunk(largeArray, chunkSize).map( /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(chunkArray) {
      var batch;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              batch = db.batch();
              _context12.next = 3;
              return chunkArray.reduce( /*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(promise, item) {
                  return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _context11.next = 2;
                          return promise;
                        case 2:
                          return _context11.abrupt("return", callback(batch, item));
                        case 3:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11);
                }));
                return function (_x15, _x16) {
                  return _ref12.apply(this, arguments);
                };
              }(), Promise.resolve());
            case 3:
              return _context12.abrupt("return", batch.commit());
            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return function (_x14) {
      return _ref11.apply(this, arguments);
    };
  }());
  return Promise.all(batches);
};
export var getNonExistentDocuments = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(collectionRef) {
    var documentRefs, documentSnapshots;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (collectionRef.listDocuments) {
              _context13.next = 2;
              break;
            }
            throw new Error('getNonExistentDocuments() must be called with firebase-admin');
          case 2:
            _context13.next = 4;
            return collectionRef.listDocuments();
          case 4:
            documentRefs = _context13.sent;
            if (documentRefs) {
              _context13.next = 7;
              break;
            }
            return _context13.abrupt("return", []);
          case 7:
            _context13.next = 9;
            return firestore.getAll.apply(firestore, _toConsumableArray(documentRefs));
          case 9:
            documentSnapshots = _context13.sent;
            return _context13.abrupt("return", documentSnapshots.reduce(function (nonExistentDocuments, documentSnapshot) {
              if (!documentSnapshot.exists) nonExistentDocuments.push(documentSnapshot);
              return nonExistentDocuments;
            }, []));
          case 11:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return function getNonExistentDocuments(_x17) {
    return _ref13.apply(this, arguments);
  };
}();
export var getNonExistentDocumentsAndDeleteSubcollections = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(collectionReference) {
    var nonExistentDocuments;
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return getNonExistentDocuments(collectionReference);
          case 2:
            nonExistentDocuments = _context15.sent;
            return _context15.abrupt("return", nonExistentDocuments.reduce( /*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(promise, documentSnapshot) {
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.next = 2;
                        return promise;
                      case 2:
                        return _context14.abrupt("return", deleteSubcollections(documentSnapshot.ref));
                      case 3:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14);
              }));
              return function (_x19, _x20) {
                return _ref15.apply(this, arguments);
              };
            }(), Promise.resolve()).then(function () {
              return nonExistentDocuments.length;
            }));
          case 4:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return function getNonExistentDocumentsAndDeleteSubcollections(_x18) {
    return _ref14.apply(this, arguments);
  };
}();